<template>
    <div>
        <template v-if="savedMethods.length">
            <template v-if="useSaved">
                <div class="form-group">

                    <div class="row" v-for="(row, index) in savedMethods" :key="index">
                        <div class="col-md-4" v-for="card in row" :key="card.id">
                            <account-reusable-payment
                                :selectable="true"
                                :selected="savedMethod == card.token"
                                :editable="false"
                                :type="card.type"
                                :last-four="card.last_four"
                                :id="card.id"
                                :provider="card.last_four"
                                :expiry="card.expires_at.date"
                                :token="card.token"
                                @chosen="switchCard"
                            ></account-reusable-payment>
                        </div>

                    </div>
                    <hr>
                    <div class="text-center">
                        <button class="btn btn-sm btn-blue" @click="useSaved = false">Use new card</button>
                    </div>
                </div>
               <!-- <div class="row">
                   <div class="col-md-3" v-for="card in savedMethods" :key="card.id">
                       <div class="box" :class="{'active': savedMethod == card.token}"  @click="switchCard(card.token)">
                           <div class="box-inner box-copy payment-card">
                               <div class="row">
                                   <div class="col-md-6" v-if="paymentIcon(card.type)">
                                       <img :src="paymentIcon(card.type)" width="50px">
                                   </div>
                                   <div class="col-md-6 text-right">
                                       <strong>Exp:</strong><br>
                                       {{ card.expires_at.date|date('M/YY') }}
                                   </div>
                               </div>
                               <strong>Card Number</strong>
                               <span class="last-four">
                                   <span class="dots">
                                        <span v-for="i in 4">
                                            &middot;
                                        </span>
                                        &nbsp;
                                        <span v-for="i in 4">
                                            &middot;
                                        </span>
                                        &nbsp;
                                        <span v-for="i in 4">
                                            &middot;
                                        </span>
                                   </span>
                                   {{ card.last_four }}
                                </span>
                           </div>
                       </div>
                   </div>
               </div> -->
            </template>
            <template v-else>
                <button class="btn btn-grey btn-sm" @click="useSaved = true">Use saved payment</button>
                <hr>
            </template>
        </template>
        <template v-if="!useSaved">
            <div class="row">
                <div class="col-md-4" :class="{ 'col-md-6' : guest, 'col-md-4' : !guest }">
                    <div class="form-group has-feedback">
                        <label for="cardNumber">Card Number</label>
                        <i class="fab form-control-feedback" v-if="cardType && cardType != 'unknown'" :class="'fa-cc-' + cardType"></i>
                        <input id="cardNumber" class="form-control" type="tel" ref="cardNumber" @keyup="updateCardNumber">
                        <template v-for="error in getErrors('card')">
                            <p class="text-danger">{{ error }}</p>
                        </template>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="expiry">Expiry</label>
                                <input id="expiry" class="form-control" @keyup="updateExpiry" ref="expiry" type="tel" placeholder="MM/YY">
                                <template v-for="error in getErrors('exp')">
                                    <p class="text-danger">{{ error }}</p>
                                </template>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="csv" class="cursor" @click="showCsvHelp = true">CSV <i class="fa fa-question-circle"></i></label>
                                <input id="csv" class="form-control" v-model="csv" type="tel">
                                <template v-for="error in getErrors('csv')">
                                    <p class="text-danger">{{ error }}</p>
                                </template>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-4" v-if="!guest">
                    <div class="save_toggle">
                        <label class="default-switch">
                            <input type="checkbox" v-model="saveCard" :value="1">
                            <span class="slider round"></span>
                        </label>
                        <span>Save card for faster checkout</span>
                    </div>
                </div>
            </div>
        </template>
        <div class="row">
            <div class="col-xs-12" :class="{'col-md-8': !useSaved, 'col-md-6': useSaved}">
                <img src="/img/orbital/info/sagepay-secure.png" class="img-responsive">
            </div>
            <div class="col-md-2" v-if="useSaved">
                CSV: <input type="text" v-model="csv" class="form-control">
                <template v-for="error in getErrors('csv')">
                    <p class="text-danger">{{ error }}</p>
                </template>
            </div>
            <div class="col-xs-12 text-right col-md-4">
                <button class="submit-btn btn btn-green" @click="submit" :disabled="processing">
                    <template v-if="!processing">
                        <i class="fa fa-lock"></i> Process Payment Securely
                    </template>
                    <template v-else>
                        <i class="fa fa-refresh fa-spin"></i> Processing
                    </template>
                </button>
            </div>
        </div>
        <modal-dialog title="3D Secure" :show="threed.show" @close="cancelThreed">
            <p>Extra authentication is required</p>
            <iframe ref="threedsecureiframe" :src="threediframesrc" class="threed-iframe" v-if="threed.show">
            </iframe>
        </modal-dialog>

        <modal-dialog title="CSV Information" :show="showCsvHelp" @close="showCsvHelp = false">
            <p>The CSV is usually the three digit number on the back of your Credit/Debit card</p>

            <figure class="credit-card">
                <img src="/images/credit-card-back.png">
            </figure>
        </modal-dialog>
    </div>
</template>

<script>
    import Order from '../../../Services/Order.js';
    import Checkout from '../../../Services/Checkout.js';
    import ModalDialog from '../../Elements/ModalDialog.vue';
    import User from '../../../Services/User.js';
    import Cleave from 'cleave.js';

    export default {
        props: {
            guest: {
                type: Boolean,
                default: true,
            }
        },
        components: {
            ModalDialog
        },
        data() {
            return {
                service: Order,
                checkout: Checkout,
                showCsvHelp: false,
                saveCard: false,
                processing: false,
                useSaved: false,
                savedMethod: null,
                user: null,
                savedMethods: [],
                threed: {
                    show: false,
                    processing: false,
                    transactionId: null,
                    paRequest: null,
                    acsUrl: null,
                    payload: {
                        MD: null,
                        MDX: null,
                        PaRes: null
                    }
                },
                card: null,
                exp: null,
                csv: null,
                cardType: null,
                errors: {
                    card: false,
                    csv: false,
                    exp: false,
                },
            }
        },
        created() {
            window.addEventListener('threed_secure_response', e => {
                this.threed.payload.MD = e.detail.MD;
                this.threed.payload.MDX = e.detail.MDX;
                this.threed.payload.PaRes = e.detail.PaRes;
                this.threed.show = false;
                this.threed.paRequest = null;
                this.threed.acsUrl = null;
                this.processThreeD();
            });
        },
        mounted() {

            // Set up the field formatting...
            let card = new Cleave(this.$refs.cardNumber, {
                creditCard: true,
                onCreditCardTypeChanged: type => {
                    this.cardType = type;
                }
            });

            let exp = new Cleave(this.$refs.expiry, {
                date: true,
                datePattern: ['m', 'y']
            });

            User.current().then(response => {
                this.user = response;

                let payments = response.reusable_payments,
                    now = moment();

                this.savedMethods = _.chunk(_.filter(payments, payment => {
                    return now.isBefore(
                        moment(payment.expires_at.date)
                    );
                }), 3);
                if (this.savedMethods.length) {
                    this.useSaved = true;
                    this.savedMethod = this.savedMethods[0].token;
                }
            }).catch(error => {
                // We don't need to do anything, this is just
                // to supress any errors
            });
        },
        computed: {
            threediframesrc() {
                return   '/checkout/threed-secure-form?paReq=' +
                    this.threed.paRequest + '&acsUrl=' + this.threed.acsUrl;
            },
        },
        methods: {
            updateCardNumber(event) {
                this.card = event.target.value;
            },
            updateExpiry(event) {
                this.exp = event.target.value;
            },
            paymentIcon(type) {
                let icon = type.toLowerCase();
                return '/img/orbital/payment-icons/' + icon +'-icon.png';
            },
            switchCard(token) {
                this.savedMethod = token;
                this.csv = null;
            },
            processThreeD() {
                this.checkout.processThreeD(
                    this.service.order.id,
                    this.threed.transactionId,
                    this.threed.payload
                ).then(response => {
                    this.$emit('complete');
                }).catch(errors => {
                    this.$emit('failed');
                    this.processing = false;
                });
            },
            resetThreeD() {
                this.threed = {
                    show: false,
                    processing: false,
                    transactionId: null,
                    paRequest: null,
                    acsUrl: null,
                    payload: {
                        MD: null,
                        MDX: null,
                        PaRes: null
                    }
                }
            },
             makeid() {
                var text = "";
                var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

                for (var i = 0; i < 5; i++)
                    text += possible.charAt(Math.floor(Math.random() * possible.length));

                return text;
            },
            cancelThreed() {
                this.threed.show = false;
                this.threed.transactionId = null;
                this.threed.paRequest = null;
                this.processing = false;
                this.$emit('fail', 'You must complete 3D Security checks');
            },
            submit() {
                this.$emit('start');

                if (!this.useSaved) {
                    if (!this.card) {
                        this.errors.card = ['Please enter your card number'];
                        return;
                    }
                    if (!this.exp) {
                        this.errors.expMonth = ['Please enter the expiry'];
                        return;
                    }
                }

                if (!this.csv) {
                    this.errors.csv = ['Please enter a CSV'];
                    return;
                }

                this.processing = true;

                this.getMerchantKey().then(response => {
                    this.process(response.data.client_token);
                }).catch(errors => {
                    this.processing = false;
                    this.$emit('failed', 'There was an issue processing your payment');
                    return false;
                });
            },
            sendToServer(card, merchantKey) {
                this.checkout.setType('SagePay')
                .process(
                    card,
                    merchantKey,
                    this.service.reference,
                    this.service.notes,
                    undefined,
                    this.saveCard,
                    this.useSaved
                ).then(response => {
                    if (response.data.threedsecure) {
                        this.threed.paRequest = response.data.paRequest;
                        this.threed.transactionId = response.data.transactionId;
                        this.threed.acsUrl = response.data.acsUrl;
                        this.$nextTick(() => {
                            this.threed.show = true;
                        });
                    } else {
                        this.$emit('complete');
                    }
                }).catch(errors => {
                    this.processing = false;
                    this.$emit('failed');
                });
            },
            process(merchantKey) {
                const csv = this.csv.toString();
                // If its a reused payment
                if (this.useSaved) {
                    sagepayOwnForm({ merchantSessionKey: merchantKey })
                    .activateReusableCardIdentifier({
                        reusableCardIdentifier: this.savedMethod,
                        securityCode: csv,
                        onActivated: result => {
                            if (result.success === true) {
                                this.sendToServer(
                                    this.savedMethod,
                                    merchantKey
                                )
                            } else {
                                this.processing = false;
                                this.$emit('failed');
                            }
                        }
                    });
                } else {
                    const card = this.card.toString().replace(/\s/g,''),
                      exp = this.exp.toString().replace('/', ''),
                      billingName = this.service.billingAddress.firstname + ' ' +  this.service.billingAddress.lastname;
                    // If it's a straight forward payment
                    sagepayOwnForm({ merchantSessionKey: merchantKey })
                        .tokeniseCardDetails({
                            cardDetails: {
                                cardholderName: billingName,
                                cardNumber: card,
                                expiryDate: exp,
                                securityCode: csv
                            },
                            onTokenised : result => {
                                if (result.success) {
                                    this.sendToServer(
                                        result.cardIdentifier,
                                        merchantKey
                                    )
                                } else {
                                    this.processing = false;
                                    this.$emit('failed');
                                }
                            }
                    });
                }
            },
            getMerchantKey() {
                return this.checkout.getProvider();
            },
            getErrors(field) {
                return this.errors[field];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .submit-btn {
        margin-top:.875em;
    }
    .threed-iframe {
        width:100%;
        height:400px;
        border:1px solid #ebebeb;
    }
    .save_toggle {
        margin-top:2em;
        display:flex;
        align-items: center;
        justify-content: flex-end
    }
    .save_toggle label {
        margin-right:10px;
        margin-bottom:0;
    }
    .new-card {
        padding:2.2em 0;
    }
    .credit-card {
        text-align:center;
    }
    .credit-card img {
        width:80%;
        margin:1em auto;
    }
    .form-control-feedback {
        font-size:2em;
        top:30px!important;
        right:10px;
        color:#b1b1b1;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/Payments/SagepayGateway.vue